import type { EmbeddedCheckoutStart } from "@/app/_services/CartService";

const key = (sessionId: string) => `embedded_checkout:${sessionId}`;

// The client secret only comes back from the create call, so the /checkout page reads it from here.
export function stashCheckout(start: EmbeddedCheckoutStart) {
  try {
    sessionStorage.setItem(key(start.session_id), JSON.stringify(start));
  } catch {}
}

export function loadCheckout(sessionId: string): EmbeddedCheckoutStart | null {
  try {
    const raw = sessionStorage.getItem(key(sessionId));
    return raw ? (JSON.parse(raw) as EmbeddedCheckoutStart) : null;
  } catch {
    return null;
  }
}

export function forgetCheckout(sessionId: string) {
  try {
    sessionStorage.removeItem(key(sessionId));
  } catch {}
}
